export default {
    SELECT_DIAMOND_DETAILS_SUCCESS : 'SELECT_DIAMOND_DETAILS_SUCCESS',
    SELECT_DIAMOND_DETAILS_LOADING : 'SELECT_DIAMOND_DETAILS_LOADING',
    SELECT_DIAMOND_DETAILS_FAIL : 'SELECT_DIAMOND_DETAILS_FAIL',
    SET_INITIAL_DIAMOND_OPTIONS: 'SET_INITIAL_DIAMOND_OPTIONS',
    SET_DIAMOND_AVAILABLE:"SET_DIAMOND_AVAILABLE",
    IS_BACK_TO_SELECT_DIAMOND_PAGE: 'IS_BACK_TO_SELECT_DIAMOND_PAGE'
}
